import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { analyticsKeys } from '@core/react-query/features/analytics'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export type UserCategoriesResponse = string[]

export const useGetUserCategories = (
  options?: UseQueryOptions<UserCategoriesResponse, RequestErrorType>,
) => {
  return useQuery({
    ...analyticsKeys.getUserCategories(),
    ...options,
  })
}
